import React, { useState } from 'react'
import './Navbar.scss'
import { Link } from "react-router-dom"
import ResponsiveNavbar from './ResponsiveNavbar'

const Navbar = () => {

  const [mobile, setMobile] = useState(false);
  return (
    <>
      <ResponsiveNavbar setNav={setMobile} nav={mobile} />
      <nav className="navbar">
        <img className="logo" src="Images/logo.png" alt="" />
        <ul
          className="nav-links"
          onClick={() => setMobile(false)}>
          <Link to="/" className="home"><li>Home</li></Link>
          <Link to="/about" className="projects"><li>AboutUs</li></Link>
          <Link to="/projects" className="projects"><li>Projects</li></Link>
          <Link to="/gallery" className="projects"><li>Gallery</li></Link>
          <Link to="/contactus" className="contact-nav"><li>Contact US</li></Link>
        </ul>
        <button className="menu-icon"
          onClick={() => setMobile(!mobile)}>
          <svg width="24" height="15" viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H23" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <path d="M1 7H23" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <path d="M1 14H23" stroke="black" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      </nav>
    </>

  )
}

export default Navbar